import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../../core/redux/authSlice'
import { persistor } from '../../../core/redux/store'
import { recruiterSidebarData } from '../../../core/common/data/json/recruiter-sidebar'

const RecruiterSidebar = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state: any) => state.auth.user);

    const visibleMenuItems = recruiterSidebarData.filter(
        (menu: any) => !menu.recruiterOnly || user?.role === "recruiter"
    );

    const handleLogout = () => {
        dispatch(logout());
        persistor.purge().then(() => {
            setTimeout(() => {
            navigate(all_routes.homesix);
            }, 0);
        });
    }

    return (
        <div className="col-lg-3 ">
            <div className="settings-sidebar theiaStickySidebar">
                <div>
                    <h6 className="mb-3">Main Menu</h6>
                    <ul className="mb-3 pb-1">
                        {visibleMenuItems.map((menu: any, index: any) => (
                            <li key={index}>
                                <Link
                                    to={menu.route}
                                    className={`d-inline-flex align-items-center ${location.pathname === menu.route || location.pathname === menu.subRoute ? 'active' : ''}`}
                                >
                                    <i className={`${menu.icon} me-2`} />
                                    {menu.title}
                                </Link>
                            </li>
                        ))}

                    </ul>
                    <hr />
                    <h6 className="mb-3">Account Settings</h6>
                    <ul>
                        <li>
                            <Link
                                to={all_routes.recruiterSettings}
                                className={`d-inline-flex align-items-center ${location.pathname.includes('settings') ? 'active' : ''}`}
                            >
                                <i className="isax isax-setting-25 me-2" />
                                Settings
                            </Link>
                        </li>
                        <li>
                            <div
                                onClick={handleLogout}
                                className="d-inline-flex align-items-center black cursor-pointer"
                            >
                                <i className="isax isax-logout5 me-2" />
                                Logout
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default RecruiterSidebar